document.addEventListener('DOMContentLoaded', function () {
    const productList = document.getElementById('product-list');
    const spinner = document.getElementById('products-listing__products-list-spinner');
    let loading = false;

    function loadNextPage() {
      if (loading || !productList.dataset.nextPage) return;

      loading = true;
      spinner.style.display = 'flex';

      fetch(productList.dataset.nextPage)
              .then(res => res.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newProducts = doc.querySelectorAll('#product-list .product-card');
                const nextPage = doc.querySelector('#product-list')?.dataset.nextPage;

                newProducts.forEach(prod => {
                  productList.appendChild(prod);
                });

                if (nextPage) {
                  productList.dataset.nextPage = nextPage;
                } else {
                  productList.removeAttribute('data-next-page');
                  spinner.remove();
                }

                loading = false;
              })
              .catch(() => {
                loading = false;
                spinner.style.display = 'none';
              });
    }

    window.addEventListener('scroll', () => {
      const rect = productList.getBoundingClientRect();
      const scrollTriggerPoint = rect.bottom - 100;

      if (scrollTriggerPoint <= window.innerHeight) {
        loadNextPage();
      }
    });
  });